export function getDebugRoutes(config) {
  return [
    {
      path: "/debug-sentry",
      element: (
        <button
          onClick={() => {
            throw new Error("This is a test/debug error!");
          }}
        >
          Debug sentry
        </button>
      ),
    },
  ];
}
